import React from 'react'
import './style.scss'
import logoVnpt from "assets/imgs/QrCodeMyVnptVer2/logo-vnpt.png"
import {Progress} from "antd";

const LoadingWithLogo = ({percent, isLoading}) => {
    return (
        <div className={`loading-wrapper ${isLoading ? "" : "hidden"}`}>
            <Progress style={{backgroundColor: "#ffffff", borderRadius: "50%"}} width={54} strokeWidth={12}
                      strokeColor={"#4788FF"} type="circle" percent={percent} showInfo={false}/>
            <img style={{position: "fixed"}}
                 src={logoVnpt}
                 alt="logo"
                 width={24}
                 height={24}
            />
        </div>
    );
};

export default React.memo(LoadingWithLogo);